import React from "react";
import Content from "../../components/Content";

import '../../App.css'


export const Home = () => {
    return (
        <div className="App">
            <div className="main">
            </div>
            <Content />
        </div>
    );
}

